<template>
  <div class="manual-payments">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" />
    <div class="filters">
      <div class="search">
        <div class="option">
          <span>用户</span>
           <a-select
    v-model:value="filters.userEmail"
    show-search
  
    allowClear
    style="width:200px"
    :default-active-first-option="false"
    :show-arrow="false"
    :filter-option="false"
    :not-found-content="null"
    :options="options"
    @search="onSearch"
    @change="onSelect"
    :getPopupContainer="
                  triggerNode => {
                    return triggerNode.parentNode || document.body;
                  }
                "
  ></a-select>
          <!-- <a-auto-complete class="autoComplete" v-model:value="filters.userEmail" :options="options"
            style="width: 200px;height: 32px;" size="large" @search="onSearch" @select="onSelect" allow-clear
            @clear="onResetComplete" placeholder="Select Username" :getPopupContainer="triggerNode => {
                return triggerNode.parentNode || document.body;
              }
              ">
          </a-auto-complete> -->
        </div>
        <div class="option" ref="marketplaceRef">
          <span>站点</span>
          <!-- <artmisads-input v-model:value="filters.marketplace" @press-enter="getPartData({})"
            placeholder="Enter Marketplace"></artmisads-input> -->
          <artmisads-select style="width: 232px" v-model:value="filters.marketplace"
            :getPopupContainer="() => marketplaceRef" :options="COUNTRY_BASE_OPTIONS" @change="onMarketplaceChange" />
        </div>

        <div class="option" ref="statusRef">
          <span>状态</span>
          <artmisads-select style="width: 232px" v-model:value="filters.status" :getPopupContainer="() => statusRef"
            :options="statusOptions" />
        </div>
      </div>
      <div class="button">
        <artmisads-button isSquare="true" type="primary" style="margin-right: 8px;" :loading="load"
          @click="searchList">搜索</artmisads-button>
        <artmisads-button isSquare="true" @click="onReset">重置</artmisads-button>
      </div>
    </div>
    <div class="add">
      <artmisads-button isSquare="true" type="primary" @click="addManualPayment">新建</artmisads-button>
    </div>
    <div class="table-data">
      <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="data" :change="onTableChange"
        :loading="load" :scroll="{ x: 1600, y: tableScrollHeight }">
        <template #bodyCell="{ column, text, index, record }">
          <template v-if="column.key === 'userName'">
            <div>
              {{ record.userName }}
            </div>
            <div>
              {{ record.userEmail }}
            </div>
          </template>
          <template v-if="column.key === 'createdAt'">
            {{ record.createdAt && moment(Number(record.createdAt)).tz(BILLING_TIME_TZ[record.marketplace]).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template v-if="column.key === 'status'">
            <span :class="record.status">
            {{ statusEnum[record.status] || record.status }}
            </span>
          </template>
          <template v-if="column.key === 'action'">
            <div class="actionBox">
              <a href="javascript:void(0)" @click="edit(record)" v-if="record.status === 'PENDING'">编辑</a>
              <a href="javascript:void(0)" @click="view(record)">查看</a>
              <a href="javascript:void(0)" @click="revoke(record)" v-if="record.status === 'PENDING'">撤销</a>
            </div>

          </template>
        </template>
      </artmisads-table>
    </div>
    <model ref="modelRef" @submit="refreshData" />
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import moment from 'moment'
import breadcrumbs from "../breadcrumbs.vue"
import { COUNTRY_BASE } from "~/contants/common"
import { useTableScrollHeight } from "@/utils/useTableScrollHeight"
import model from "./components/model.vue"
import { financeApi } from "~/server/operator/finance"
import { Modal, message } from 'ant-design-vue'
import { BILLING_TIME_TZ } from '~/contants/common';
const columns = [
  {
    title: "创建日期",
    key: "createdAt",
    dataIndex: "createdAt",
    align: 'center'
  },
  {
    title: "站点",
    dataIndex: "marketplace",
    key: "marketplace",
    align: 'center'
  },
  {
    title: "用户账户",
    dataIndex: "userName",
    key: "userName",
    align: 'center'
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    align: 'center'
  },
  {
    title: "操作人",
    dataIndex: "createdByName",
    key: "createdByName",
    align: 'center',

  },
  {
    title: "备注",
    dataIndex: "adjustmentReason",
    key: "adjustmentReason",
    align: 'center',
    width: 250
  },
  {
    key: "action",
    fixed: 'right',
    title: "操作",
    align: 'center'
  },
]
const options = ref([])

const data = ref([])
const modelRef = ref(null)
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
})
const marketplaceRef = ref(null)
const statusRef = ref(null)
const COUNTRY_BASE_OPTIONS = ref(COUNTRY_BASE.map((item) => {
  item.value = item.host
  item.label = item.host
  return item
}))
COUNTRY_BASE_OPTIONS.value.unshift({
  label: '全部',
  value: '',
})
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 280,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350
})
const load = ref(false)
const statusEnum = {
  PENDING: '未生效',
  EFFECTIVE: '已生效',
  CANCELLED: '已撤销',
}
const statusOptions = ref([
  {
    label: '全部',
    value: '',
  },
  {
    label: '未生效',
    value: 'PENDING',
  },
  {
    label: '已生效',
    value: 'EFFECTIVE',
  },
  {
    label: '已撤销',
    value: 'CANCELLED',
  },
])
const breadcrumbsData = ref({
  title: "Manual Payments",
  des: "",
  links: [
    {
      name: "Home",
      path: "/operator/users",
    },
    {
      name: "Operation",
      path: "/operator/operation/manualPayments",
    },
    {
      name: "Manual Payments",
      path: "/operator/operation/manualPayments",
    },
  ],
})
const userInfoArr=ref([])
const filters = ref({
  marketplace: '',
  userId: '',
  status: '',
  userEmail:''
})
const onSearch = e => {
  const parma = {
    email: e,
  }
  getUser(parma)
}
const onSelect=e=>{
  const res=userInfoArr.value.find(v=>v.userId == e);
  filters.value.userId=res.userId;
  filters.value.userEmail=res.email;
 
}
const onResetComplete=()=>{
  filters.value.userId=''
}
const getUser=async(parma)=>{
  const res=await financeApi.getUserInfo(parma)
  options.value=res.map(item=>({
    label: item.email,
    value: item.userId,
  }))
  userInfoArr.value=res
}
// setTimeout(() => {
//   modelRef.value.show()
// }, 1000);
const addManualPayment = () => {
  modelRef.value.show({
    type: 'add'
  })
}

const onReset = () => {
  filters.value = {
    userEmail:'',
    marketplace: '',
    userId: '',
    status: ''
  }
  getData({})
}
const onTableChange = ({ current, pageSize }) => {
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getData({ page: current, size: pageSize })
}
const getData = async (params) => {
  load.value = true
  if (Object.keys(params).length === 0) {
    pagination.current = 1
  }
  let _params = {
    page: 1,
    size: pagination.size,
    // marketplace: filters.marketplace,
    // sellerId: filters.sellerId,
    // bd: filters.bd
  }
  let newparams = { ..._params, ...params }
  newparams = Object.keys(newparams).reduce((acc, key) => {
    if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ""
    ) {
      acc[key] = newparams[key]
    }
    return acc
  }, {})

  financeApi.manualAdjustments(newparams).then(res => {
   
    data.value = res.data || []
    pagination.total = res.total || 0
    load.value = false

  })
}
const searchList=()=>{
  getData({
    marketplace: filters.value.marketplace,
    userId: filters.value.userId,
    status: filters.value.status,
  })
}
const refreshData = (reset=true) => {
  getData({})
  if(reset){
  onReset()
  }
}
const onMarketplaceChange = (e) => {
  console.log(e, 'e')
}
const edit = (record) => {

  modelRef.value.show({
    type: 'edit',
    id: record.id
  })
}
const view = (record) => {
  modelRef.value.show({
    type: 'view',
    id: record.id
  })
}
const revoke = (record) => {
 
  Modal.confirm({
    title: '确认撤销该条记录吗？',
    okText: '确认',
    cancelText: '取消',
    okType: 'danger',
    onOk: () => {
      financeApi.cancelManualPayment({ id: record.id }).then(res => {
        if (res.success) {
          message.success('撤销成功')
          refreshData(false)
        } else {
          message.error(res.message || '取消失败')
        }
      })
    }
  })
}
getData({})
</script>
<style scoped lang="less">

.PENDING{
  color: #7653DA;
}
.EFFECTIVE{
  color: #009947;
}
.CANCELLED{
  color: #EB4E3D;
}
.actionBox {
  display: flex;
  gap: 12px;
}

.autoComplete {
  :deep(.ant-select-selector) {
    height: 32px !important;

  }

  :deep(.ant-select-selection-search-input) {
    height: 32px !important;
  }

  :deep(.ant-select-selection-placeholder) {
    line-height: 32px !important;
  }
}

.add {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
}

.manual-payments {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}

.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    >a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      >span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}

.filters {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;

    .option {

      >span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}
</style>
